import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import jsonexcel from '../../components/jsonexcel.vue';
export default {
  __name: 'jsonexcelPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JSON 转 Excel / Excel 转 JSON",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(jsonexcel)]),
        _: 1
      });
    };
  }
};